import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 40px 0;
  padding: 20px 10px;
  background: url("/images/mask-legal-advice.svg") #0e5728;
  background-size: cover;
  background-repeat: norepeat;
  border-radius: 8px;
  @media print {
    display: none;
  }
`;

export const Header = styled.div`
  font-size: 24px;
  line-height: 28px;
  font-weight: 900;
  margin-bottom: 20px;
  color: #fff;
  text-align: center;
`;

export const HtmlLink = styled.a`
  display: inline-block;
  margin: auto;
`;
